// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".round[data-v-2c0324ae]{border-radius:18px}.btn-c[data-v-2c0324ae]{border:2px solid #000;font-weight:500;border-radius:18px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
